module.exports = __webpack_public_path__ + "static/Pt08-20102d8883d5ced84c57c6d9130438eb.jpg";